export default __webpack_public_path__ + "static/media/m_attention.aa4ed06d.png";